import { Checkbox, Typography } from '@mui/material'
import Box from '@mui/material/Box'
import { CSSProperties } from 'react'
import { Controller } from 'react-hook-form'

import { ControlProps } from 'helper/control'
import { Option } from 'types/option'
import { FAVORITE_WORK, FavoriteWork } from 'types/securityDetail'

type FieldType = Set<FavoriteWork>

const options: Option<FavoriteWork>[] = [
  {
    value: FAVORITE_WORK.DAY_SHIFT,
    label: '日勤',
  },
  {
    value: FAVORITE_WORK.NIGHT_SHIFT,
    label: '夜勤',
  },
]

export default function FavoriteWorkForm(props: ControlProps) {
  const handleToggle =
    (
      field: {
        value: FieldType
        onChange: (value: FieldType) => void
      },
      value: FavoriteWork,
    ) =>
    (): void => {
      const newValue: FieldType =
        field.value == null ? new Set() : new Set(field.value)

      if (newValue.has(value)) {
        newValue.delete(value)
      } else {
        newValue.add(value)
      }
      field.onChange(newValue)
    }

  const isChecked = (
    field: {
      value: FieldType
    },
    value: FavoriteWork,
  ) => {
    if (field.value == null) {
      return false
    }

    return field.value.has(value)
  }

  return (
    <Controller
      {...props.c}
      render={({ field }) => (
        <>
          <Box style={containerStyle}>
            {options.map((option) => (
              <Box
                key={option.value}
                style={checkboxContainerStyle}
                onClick={handleToggle(field, option.value)}
              >
                <Checkbox
                  style={checkboxStyle}
                  checked={isChecked(field, option.value)}
                />
                <Typography>{option.label}</Typography>
              </Box>
            ))}
          </Box>
        </>
      )}
    />
  )
}

const containerStyle: CSSProperties = {
  display: 'flex',
  gap: '16px',
}

const checkboxContainerStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  cursor: 'pointer',
}

const checkboxStyle: CSSProperties = {
  padding: 0,
}
